export default __webpack_public_path__ + "static/media/WhiteExclamatry.a4cdf3d9.svg";